//  -*-web-*-
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles((theme) => ({
    root: { width: 800, },
    margin: { height: theme.spacing(3), },
}));

var marks = [ { value: -60, label: 'history', },
		{ value: -30, label: 'match', },
		{ value: 0,label: 'day', },
		{ value: 20, label: 'forecast', }, ];

const [HISTORY, MATCH, DAY, FORECAST, BULLETS, NOTHING] = [0, 1, 2, 3, 4, 5];
//var logTxt = ["HISTORY", "MATCH", "DAY", "FORECAST", "BULLETS", "NOTHING"];

function setMarks(val) {
    val.forEach((v, i, arr) => { marks[i].value = v; });
}


export function ChartMultiSlider(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(props.val);
    const [oldValue, setOldValue] = React.useState(props.val);
    const [min, setMin] = React.useState(props.min);
    const [max, setMax] = React.useState(props.max);
    //setMarks(props.val);

    // --------------------------------------------------------------------
    // Handle changes in the slider
    // --------------------------------------------------------------------
    const handleChange = (event, newValue) => {
	let [index, moved] = movedUpdate(oldValue, newValue);
	Math.min(index, index);  // To avoid unused variable warning
	let nVal = newValue;
	//console.log(oldValue, newValue);
	//console.log(logTxt[index] + " moved " + moved);
	if (newValue[DAY] !== oldValue[DAY]) {
	    setMin(min - moved);
	    setMax(max - moved);
	    nVal.forEach((v, i, arr) => { arr[i] -= moved; });
	}
	setOldValue(value);
	setMarks(nVal);
	setValue(nVal);
	if (props.onClick) {
	    props.onClick(props, nVal);
	    let props2 = { kind: "datedelta" };
	    if (moved) props.onClick(props2, moved);
	}
	//console.log("New: " + nVal);
    };
    
    // --------------------------------------------------------------------
    // Handle ongoing sliding of the slider
    // --------------------------------------------------------------------
    const handleSlide = (event, newValue) => {
	let [index, moved] = movedUpdate(value, newValue);
	const margin = 10;
	// console.log(logTxt[index] + " moved " + moved);

	function maxVal(border, value) {
	    return Math.max(newValue[border] + margin, newValue[value]); }
	function minVal(border, value) {
	    return Math.min(newValue[border] - margin, newValue[value]); }
	
	if (moved) {	    
	    if (index===DAY) {
		let over = newValue[FORECAST] + moved + margin - max;
		//console.log("over: " + over);
		if (over > 0) {
		    moved -= over;
		    newValue[DAY] -= over; 
		}
		let under = newValue[HISTORY] + moved - margin - min;
		if (under < 0) {
		    moved -= under;
		    newValue[DAY] -= under; 
		}
		newValue[HISTORY] += moved; 
		newValue[MATCH] += moved; 
		newValue[FORECAST] += moved;
		
	    } else if (index===MATCH) {
		newValue[MATCH] = maxVal(HISTORY, MATCH);
		newValue[MATCH] = minVal(DAY, MATCH);
	    } else if (index===FORECAST) {
		newValue[FORECAST] = maxVal(DAY, FORECAST);
	    } else if (index===HISTORY) {
		newValue[HISTORY] = minVal(MATCH, HISTORY);
	    }
	    setMarks(newValue);
	    setValue(newValue);
	}
    };

    // --------------------------------------------------------------------
    // Return the component to be rendered
    // --------------------------------------------------------------------
    return (
	<div className={classes.root}>
	<Slider
	defaultValue={[-60,-30,0,14]}
        aria-labelledby="range-slider-custom"
	max={max}
	min={min}
	track={false}
	valueLabelDisplay="auto"
	onChange={handleSlide}
	onChangeCommitted={handleChange}
	marks={marks}
	/>
	</div>
    );
}

// --------------------------------------------------------------------
// Update moved data
// --------------------------------------------------------------------
function movedUpdate(oldVal, newVal) {
    //console.log(oldVal, newVal);
    let moved = 0;
    let index = NOTHING;
    for (let i=0; i < BULLETS; i++) {
	//console.log(i);
	if (newVal[i] !== oldVal[i]) {
	    index = i;
	    moved = newVal[i] - oldVal[i];
	    break;
	}
    }
    //console.log(index + " moved " + moved);
    return [index, moved];
}
